import { useTranslation } from "react-i18next";
import { OptionGroup } from "components/Styled";
import SwitchField from "components/Forms/SwitchField";
import ButtonWithLoading from "components/ButtonWithLoading";
import { useFetch } from "utils/api/useFetch";
import FilepathSelector from "./FilepathSelector";
import SelectCopyPolicy from "./SelectCopyPolicy";
import { ContentWrapper } from "./Styled";
import { emptyLocation } from "./utils";

import { useRuleContext } from "../../context/ruleContext";

import { SwitchProps } from "@material-ui/core";
import { CopyPolicy } from "@dashboard-v3/api";
import { ControlProps, LocationUpdate } from "./types";
import { State } from "../../context/types";
import { getCloudStorage as getStorage } from "pages/Rules/Form/context/ruleSelectors";

export default function FilepathLocation({
  controls,
  handleControls,
}: ControlProps) {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const storage = getStorage(state.rule);
  const { enablePolicy } = controls;
  const { copyPolicy } = storage?.location || emptyLocation();

  const { data: policies, isLoading } = useFetch<CopyPolicy[]>(
    "/copy-policies?limit=1000",
    { cacheIndividuals: true }
  );

  /** Dispatch the change of location in rule */
  const updateLocation = (changes: LocationUpdate) => {
    dispatch({
      type: "updateStep",
      payload: {
        step: "filePath",
        changes: { location: changes },
      },
    });
  };

  const handleConfirm = () => {
    dispatch({ type: "confirmStep", payload: "storageFilepath" });
  };

  const onCopyPolicyChange: SwitchProps["onChange"] = event => {
    const { checked = false } = event.target;
    handleControls("enablePolicy", checked);
  };

  return (
    <ContentWrapper>
      {!enablePolicy && <FilepathSelector />}

      <OptionGroup>
        <SwitchField
          style={{ marginBottom: "5px" }}
          name="enablePolicy"
          label={t("storageFilepath.copyPolicies.enable")}
          value={enablePolicy}
          onChange={onCopyPolicyChange}
        />
        {enablePolicy && (
          <SelectCopyPolicy
            options={policies}
            storageProvider={storage.provider}
            loading={isLoading}
            value={copyPolicy}
            onChange={updateLocation}
          />
        )}
      </OptionGroup>
      <ButtonWithLoading
        variant="contained"
        size="large"
        fullWidth
        disableElevation
        loading={state.asyncStatus === "validate_filename_format"}
        disabled={isConfirmDisabled(state)}
        onClick={handleConfirm}
      >
        {t("confirm")}
      </ButtonWithLoading>
    </ContentWrapper>
  );
}

function isConfirmDisabled(state: State) {
  if (state.steps?.storageFilepath?.done) return true;
  return !state.steps?.storageFilepath?.valid;
}
